import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Logo = styled.img`
  width: 100%;
`;

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const LogoWrapper = styled.div`
  margin: auto 12px;
  display: flex;
  width: 160px;
  height: 54px;
  align-items: center;
`;
